import {gql} from '@apollo/client';
import React from 'react';

import {useSkippableBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

import {RunSchemaSubdependencyInputQuery} from './__generated/RunSchemaSubdependencyInputQuery';
import BaseSchemaSubdependencyInput from './BaseSchemaSubdependencyInput';
import {ChildDependencyTypes} from './ChildDependencyTypes';

export const RUN_SCHEMA_SUBDEPENDENCY_INPUT_QUERY = gql`
  query RunSchemaSubdependencyInputQuery($id: StrictString!) @skipAudit @engComponent(name: BENCHLING_APPS) {
    runSchema(id: $id) {
      ... on RunSchemaNode {
        ...RunSchemaGraphQL
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('RunSchema').fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export default function RunSchemaSubdependencyInput({
  subdependencies,
  onChange,
  dependencyValidation,
  updateDependencyConfigValidation,
  disabled,
  parentDependencySelectedId,
}: ChildDependencyTypes): JSX.Element | null {
  const result = useSkippableBenchlingQuery<RunSchemaSubdependencyInputQuery>(
    RUN_SCHEMA_SUBDEPENDENCY_INPUT_QUERY,
    {
      skip: parentDependencySelectedId == null,
      variables: {id: parentDependencySelectedId},
    }
  );

  return (
    <BaseSchemaSubdependencyInput<RunSchemaSubdependencyInputQuery>
      subdependencies={subdependencies}
      onChange={onChange}
      dependencyValidation={dependencyValidation}
      updateDependencyConfigValidation={updateDependencyConfigValidation}
      disabled={disabled}
      result={result}
      getSchemaFromResult={(result) => result.data.runSchema}
    />
  );
}
